<template lang="">
  <footer>
    <div class="container">
      <div class="row align-items-center ">
        <div class="col">
          <img
            v-bind:src="'' + this.getContent?.content?.betwayLogoImageUrl"
            alt="Betway Logo"
            class="img-fluid foot-logo pe-1"
          />

          <img
            v-bind:src="'' + this.getContent?.content?.eighteenLogoImageUrl"
            alt="18"
            class="img-fluid age-logo"
          />
        </div>
        <div class="col">
        </div>
      </div>
      <div class="row">
        <p
          class="text-center" style="font-size:14px;"
          v-html="this.getContent?.content?.pageFooterContent"
        ></p>
        <p v-html="this.getContent?.content?.pageFooterContentVersion"></p>
      </div>
      <div class="row align-items-center">
        <div class="col">
          <i class="sprite sprite-westerncapegovernment"></i>
        </div>
        <div class="col">
          <i class="sprite sprite-nationalgamblingboard"></i>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { store } from "../store/store.js";

export default {
  computed: {
    getContent() {
      return {
        content: {
          // footer Images
          betwayLogoImageUrl: store?.content?.betwayLogoImage,
          eighteenLogoImageUrl: store?.content?.eighteenLogoImage,

          //footer text
          responsibleGamingText: store?.content?.responsibleGamingText,
          ContactUsText: store?.content?.ContactUsText,

          //footer content
          pageFooterContent: store?.content?.pageFooterContent,
          pageFooterContentVersion: store?.content?.pageFooterContentVersion,
        },
      };
    },
  },
};
</script>

<style scoped>
.container a {
    color: #fff;
    font-size: 15px;
    display: block;
  
}
.img-fluid {
  max-width: 130px !important;
  height: auto;
  margin-right: 8px;
}
footer {
  border-top: 1px solid #ccc;
  color: #fff;
  background-color: #333;
}
.legal {
  border-top: 1px solid #ccc;
  color: #fff;
  background-color: #333;
}

.pt-5 {
  padding-top: 3rem !important;
}
.container {
  max-width: 1320px;
  padding-top: 25px;
  padding-bottom: 8px;
}
.align-items-center {
  align-items: center !important;
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  margin-left: calc(var(--bs-gutter-x) * -0.5);
}
.col {
  flex: 1 0 0%;
}
.foot-logo {
  max-width: 120px;
}
.pe-1 {
  padding-right: 0.25rem !important;
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
img,
svg {
  vertical-align: middle;
}
.age-logo {
  filter: invert(1);
  max-width: 35px;
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
img,
svg {
  vertical-align: middle;
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  margin-left: calc(var(--bs-gutter-x) * -0.5);
}

.align-items-center {
  align-items: center !important;
}
.sprite-westerncapegovernment {
  width: 150px;
  height: 66px;
  background-position: -625px -408px;
}
.sprite-nationalgamblingboard {
  width: 150px;
  height: 49px;
  background-position: -5px -559px;
}
.sprite {
  background-image: url(https://cdn2.betway.co.za/images/shared/sprite/spritesheet.png);
  background-repeat: no-repeat;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
p{
  margin-bottom: unset!important;
}

@media (max-width: 1024px) {

  .container {
  max-width: 1320px;
  padding-top: 25px;
}
}

</style>
